import React from 'react';
import stylex from '@stylexjs/stylex';
import { CalendarIcon } from '@shared/assets/icons';
import { SendingStatus } from '@features/ticket-invite-sending-status';
import { SwitcherLabelRow } from '@shared/ui/switcher-label-row';
import { styles } from './styles';

export interface ActivitySwitcherProps {
  isActive: boolean | undefined;
  dateStart: string | undefined;
  statusText: string | undefined;
  onToggle: () => void;
}

export const ActivitySwitcher = React.memo<ActivitySwitcherProps>(({ isActive, dateStart, statusText, onToggle }) => (
  <div {...stylex.props(styles.row)}>
    <SwitcherLabelRow label="Активность" isActive={!!isActive} onToggle={onToggle} />
    <p {...stylex.props(styles.dateLabel)}>
      <span {...stylex.props(styles.date)}>
        {dateStart ? dateStart.split('T')[0].split('-').reverse().join('.') : ''}
      </span>
      <CalendarIcon />
    </p>
    {statusText && <SendingStatus status={statusText} />}
  </div>
));
